import { useCallback } from 'react';
import { useCanViewAllTenants } from '../../common/useCanViewAllTenants';
import { HelpArticleMeta } from './helpCenter';
import { isArticleVisible } from './helpVisibilityRules';

/** Visibility predicate for the signed-in user. The gate reuses the check of
 *  the feature itself, so the help centre and the feature cannot disagree
 *  about who has it. Rule: `helpVisibilityRules.ts`. */
export const useHelpArticleVisibility = (): ((article: HelpArticleMeta) => boolean) => {
    const canViewAllTenants = useCanViewAllTenants();
    return useCallback((article: HelpArticleMeta) => isArticleVisible(article, { canViewAllTenants }), [canViewAllTenants]);
};
